var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowNext = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "#001E3C"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.505 18.008c-.12 0-.25-.05-.35-.14a.495.495 0 0 1-.01-.71l5.43-5.65-5.43-5.66c-.19-.2-.19-.52.01-.71s.52-.18.71.01l5.77 6c.19.19.19.5 0 .69l-5.76 6c-.1.1-.23.15-.36.15z"
})));
export { SvgArrowNext as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMDZkMzFkZDlhMTg5YjkyMzlkOWU2ODRjODg0MTVmZGEuc3ZnIjs=";